/**
 * Default values for Flow resource creation
 * Based on Flow CRD definition (synstream.rtsinv.com/v1)
 */

// Per-instance build args: the namespace the auth service runs in, and the flow image
// a side-loaded cluster actually has. See Dockerfile.
const platformNamespace = (import.meta.env.VITE_PLATFORM_NAMESPACE as string) || 'synstream-project'

export const defaultImage = {
  url: 'ghcr.io/rootsinnovation/synstream-console',
  tag: (import.meta.env.VITE_FLOW_IMAGE_TAG as string) || 'v1.2.0'
}

export const defaultEnv = {
  variables: {
    AUTH_BASE_URL: `synstream-auth.${platformNamespace}`,
    AUTH_ENABLED: 'true',
    AUTH_LOGIN_PATH: '/api/v2/synstream/login',
    AUTH_LOGOUT_PATH: '/api/v2/synstream/logout',
    AUTH_PORT: '8080',
    AUTH_TOKEN_PATH: '/api/v2/synstream/token',
    AI_HOST: `synstream-ai.${platformNamespace}`,
  },
  // The audit ingest token is injected by the operator from this Secret. It
  // must not go in `variables`: that object is a browser-side constant and
  // would ship the token to every client and store it in the Flow spec.
  // `optional` keeps flows starting on deployments that have no audit sink.
  secretEnvFrom: [
    { name: 'synstream-app-secret', optional: true }
  ]
}

export const defaultIngress = {
  className: (import.meta.env.VITE_FLOW_INGRESS_CLASS as string) || 'nginx',
  tlsSecretName: (import.meta.env.VITE_FLOW_TLS_SECRET as string) || ''
}

export const defaultFlowConfig = {
  replicas: 1,
  image: defaultImage,
  imagePullPolicy: (import.meta.env.VITE_FLOW_IMAGE_PULL_POLICY as string) || 'Always',
  service: {
    type: 'ClusterIP',
    port: 1880,
    targetPort: 1880
  },
  storage: {
    enabled: false,
    size: '10Gi',
    deletionPolicy: 'Retain' as const
  }
}

